// extracted by mini-css-extract-plugin
module.exports = {"name":"Sidebar_name__7f89o","btnWrapper":"Sidebar_btnWrapper__WbBpo","wrapper":"Sidebar_wrapper__2AvjK","closeIcon":"Sidebar_closeIcon__1aIVD"};